export default "__VITE_ASSET__C_v7V4MQ__"